export default {
      id: "oc-menu-k8s-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-k8s",
      toString: function () {
        return this.url;
      }
    }